'use client'

import { useEffect, useRef } from 'react'

export default function HubSpotMeetings({
  meetingUrl,
}: {
  meetingUrl: string
}) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    // Clear any previous content
    container.innerHTML = ''

    // Create the HubSpot meetings embed div
    const embedDiv = document.createElement('div')
    embedDiv.className = 'meetings-iframe-container'
    embedDiv.setAttribute('data-src', `${meetingUrl}?embed=true`)
    container.appendChild(embedDiv)

    // Load the HubSpot meetings embed script
    const script = document.createElement('script')
    script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js'
    script.async = true
    container.appendChild(script)

    return () => {
      if (container) {
        container.innerHTML = ''
      }
    }
  }, [meetingUrl])

  return (
    <div
      ref={containerRef}
      className="w-full overflow-hidden"
      style={{ minHeight: '680px' }}
    />
  )
}
